import { z } from "zod";

import { locationSavedSchema } from "./location-saved";
import { packagingComponentCartonSavedSchema } from "./packaging-component-carton-saved";
import { packagingComponentLabelSavedSchema } from "./packaging-component-label-saved";

export const savedPackagingSolutionSchema = z.object({
	tenantId: z.string(),
	internalUniqueId: z.string(),
	batchId: z.string().nullable(),
	alias: z.string(),
	licensePlateNumber: z.string().nullable().optional(),
	classification: z.string().nullable().optional(),
	importDate: z.string(),
	createByDate: z.string().optional(),
	releasedForProductionDate: z.string(),
	location: locationSavedSchema,
	cartons: z.array(packagingComponentCartonSavedSchema),
	labels: z.array(packagingComponentLabelSavedSchema),
	attributes: z.record(z.string(), z.string()),
	estimatedTimeToPack: z.string(),
	cartonPropertyGroups: z.array(z.string()),
	// SavedPackagingSolution specific fields
	id: z.string(),
	quantity: z.number(),
	isArchived: z.boolean().optional(),
	description: z.string().nullable().optional(),
	expireAfter: z.string().optional(),
	scope: z.string().optional(),
	lastupdated: z.string().optional(),
	isFavorite: z.boolean().optional(),
	executionSource: z.string().optional(), // TODO remove executionSource
});

export type SavedPackagingSolution = z.infer<typeof savedPackagingSolutionSchema>;
